import { Inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';
import {Observable, throwError as observableThrowError, of} from 'rxjs';
import {map, shareReplay, catchError} from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private domain: string = '';
  private _loginUrl: string = '';
  private _url: string = '';

  

  constructor(@Inject(DOCUMENT) private _doc: Document, 
              private http: HttpClient,
              private httpService: HttpService,
              @Inject(PLATFORM_ID) private platformId: Object) {
    
    this.domain = environment.domain;
    this._loginUrl = this.domain + 'auth/publicToken';
    this._url = this.domain + 'auth/';
  }


  public requestUpgradeToken(offer_alias_id: string, prop_id: string): Observable<any>{
    const url = this._url  + 'requestUpgradeToken';
    return this.httpService
      .post(
        url,
        {'alias_id' : offer_alias_id,
         'prop_id' : prop_id}
      ).pipe(shareReplay(1));
  }

  public requestUpgradeConfirmationValidation(offer_alias_id: string, prop_id: string, offer_set_id: string, 
                                              offer_id: string, base_room_category_name: string, bar_price: number): 
                                              Observable<any>{  
    
    const url = this._url  + 'requestUpgradeConfirmationValidation';
    return this.httpService
      .post(
        url,
        {'alias_id' : offer_alias_id,
         'prop_id' : prop_id,
         'base_room_category_name' : base_room_category_name,
         'offer_set_id' : offer_set_id,
         'offer_id' : offer_id,
         'bar_price' : bar_price.toString()
        }        
      ).pipe(shareReplay(1));
  }

  public validateRequest(prop_id: string, offer_alias_id: string, token: string): Observable<any>{
    const url = this._url  + 'validateRequest';
    const body = 
      JSON.stringify({
        'alias_id': offer_alias_id,
        'prop_id': prop_id,
        'token': token
      });

    return this.httpService.post(url, body);
  }

  public isLoggedIn() {
    return (localStorage.getItem('id_token'));
  }

  private storeToken(token: any) {
      
      localStorage.setItem('id_token', token.jwt);
      localStorage.setItem('XSRF-TOKEN', token['xsrf-token']); 
  }

  public getTokenInfo() {
    return JSON.parse(localStorage.getItem('user')!);
  }

  public getPerms() {
    return this.getTokenInfo() ? this.getTokenInfo()['perm'] : [];
  }

  private getCookie(name: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  }

  private clearCookie(name: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  }

  public validateTokenFromCookie(): Observable<{success: boolean, error?: string}> {
    // Step 1: Check if there's a cookie to transfer to localStorage
    const cookieToken = this.getCookie('auth_token');

    if (cookieToken && isPlatformBrowser(this.platformId)) {
      // Transfer cookie to localStorage
      localStorage.setItem('id_token', cookieToken);
      // Clear cookie immediately after transfer
      this.clearCookie('auth_token');
    }

    // Step 2: Validate token from localStorage
    const token = isPlatformBrowser(this.platformId) ? localStorage.getItem('id_token') : null;

    if (!token) {
      return of({success: false, error: 'no_token'});
    }

    // DEV MODE BYPASS: Skip API validation in local environment
    // TODO: Remove this bypass once backend /account/status endpoint is ready
    // and XSRF-TOKEN has been made optional
    if (environment.environmentName === 'local') {
      console.warn('[DEV MODE] Bypassing token validation - backend not required');
      return of({success: true});
    }

    // Step 3: Validate token via API
    return this.httpService.getSystemStatus().pipe(
      map((response: any) => {
        // Success - token is valid
        return {success: true};
      }),
      catchError((error: any) => {
        // Validation failed - clear localStorage
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('id_token');
          localStorage.removeItem('XSRF-TOKEN');
        }
        return of({success: false, error: 'invalid_token'});
      })
    );
  }

}
